export default __webpack_public_path__ + "static/media/ed-pastor-at-pakistan.9b834b3a.jpg";